{"order_item_report":{"type":"item","name":"Invoice","slug":"order_item_report","class":"App\\Entity\\Order\\Order"}}